import { render } from "./AlatDewan.vue?vue&type=template&id=4fe02d14&scoped=true"
import script from "./AlatDewan.vue?vue&type=script&lang=js"
export * from "./AlatDewan.vue?vue&type=script&lang=js"

import "./AlatDewan.vue?vue&type=style&index=0&id=4fe02d14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe02d14"]])

export default __exports__